import React from "react";
import { Typography, Paper, Box } from "@mui/material";
import { motion } from "framer-motion";

const MotionBox = motion(Box);
const MotionPaper = motion(Paper);

const containerVariants = {
  hidden: {},
  show: {
    transition: {
      delay: 0.2,
      staggerChildren: 0.2,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.1, ease: [0.25, 0.8, 0.25, 1] },
  },
};

export default function OrgListCard({ orgs = [], handleClick }) {
  const isEmpty = orgs.length === 0;

  return (
    <MotionBox
      initial="hidden"
      animate="show"
      variants={containerVariants}
      sx={{
        width: "90%",
        m:'2rem',
        p: 4,
        borderRadius: 4,
        backgroundColor: "rgba(255, 255, 255, 0.05)",
        backdropFilter: "blur(14px)",
        border: "1px solid rgba(255, 255, 255, 0.15)",
        boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
        transition: "all 0.4s ease",
      }}
    >
      <Box mb={3}>
        <Typography variant="h6" sx={{ color: "#222" }}>
          {isEmpty
            ? "No organizations found"
            : `Found ${orgs.length} organization${orgs.length > 1 ? "s" : ""}`}
        </Typography>

        <Typography variant="body2" sx={{ color: "#666", mt: 0.5 }}>
          {isEmpty
            ? "Please refine your search or try again later."
            : "Please select one to continue"}
        </Typography>
      </Box>

      {!isEmpty &&
        orgs.map((org) => (
          <MotionPaper
            key={org.id}
            layout
            variants={itemVariants}
            whileHover={{
              scale: 1.01,
              boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
              transition: { duration: 0.2 },
            }}
            whileTap={{ scale: 0.98 }}
            onClick={() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
  handleClick(org);
}}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 2.5,
              mb: 2,
              borderRadius: 3,
              backgroundColor: "rgba(255, 255, 255, 0.03)",
              backdropFilter: "blur(10px)",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              color: "#333",
              cursor: "pointer",
              transition: "all 0.3s ease",
              "&:hover .orgName": { color: "#1976d2" },
              "&:hover .orgAddress": { color: "#1976d2" },
            }}
          >
            <Typography
              variant="subtitle1"
              className="orgName"
              sx={{ fontWeight: 600, color: "#333", transition: "color 0.3s" }}
            >
              {org.name}
            </Typography>
            <Typography
              variant="body2"
              className="orgAddress"
              sx={{ color: "#666", transition: "color 0.3s" }}
            >
              {org.address}
            </Typography>
          </MotionPaper>
        ))}
    </MotionBox>
  );
}
